module.exports = __webpack_public_path__ + "img/tree-03-b-leaves.1d8c4675.png";